import I18n from 'I18n';
import styled from 'styled-components';
// NOTE: despite the `conversations-` prefix, this package (as of 2023-08-29) has no conversations-specific dependencies
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReassignmentSelectInput = styled.div.withConfig({
  displayName: "ReassignmentSelectInputPlaceholder__ReassignmentSelectInput",
  componentId: "hmaie2-0"
})(["padding:0 10px 0 0;width:150px;height:24px;display:flex;align-items:center;"]);
const Details = styled.div.withConfig({
  displayName: "ReassignmentSelectInputPlaceholder__Details",
  componentId: "hmaie2-1"
})(["display:flex;flex-direction:column;justify-content:space-around;width:100%;height:100%;"]);
const ReassignmentSelectInputPlaceholder = () => /*#__PURE__*/_jsxs(ReassignmentSelectInput, {
  "aria-busy": true,
  "aria-label": I18n.text('routing-ui.reassignment.dropdownPlaceholder'),
  "aria-live": "polite",
  disabled: true,
  "data-test-id": "reassignment-select-placeholder",
  role: "progressbar",
  children: [/*#__PURE__*/_jsx(SkeletonCircle, {
    size: 24,
    className: "m-right-1",
    use: "on-shade"
  }), /*#__PURE__*/_jsx(Details, {
    children: /*#__PURE__*/_jsx(SkeletonBox, {
      width: "100%",
      height: "0.75em",
      use: "on-shade"
    })
  })]
});
ReassignmentSelectInputPlaceholder.displayName = 'ReassignmentSelectInputPlaceholder';
export default ReassignmentSelectInputPlaceholder;